import Decimal from 'decimal.js'
import moment from 'moment'

import config from 'config'
import { FINANCE_API } from 'modules/banking/constants'
import { transactionTypes } from '@/modules/base/util/constants'
import lang from '@/lang'

const {
  ACCOUNT_TYPE: { CLEARING_ACCOUNT, OFFLINE_ACCOUNT },
} = FINANCE_API

const { TRANSACTION_TYPE_INVOICE, TRANSACTION_TYPE_CREDIT_NOTE, TRANSACTION_TYPE_EXPENSE, TRANSACTION_TYPE_REVENUE, TRANSACTION_TYPE_MANUAL_CREDIT_NOTE } = transactionTypes

const getBankAccountId = (bankAccounts) => {
  const { id: offlineKontoId } = bankAccounts.find(bankAccount => bankAccount.accountType === OFFLINE_ACCOUNT) || {}
  const { id: clearingAccountId } = bankAccounts.find(bankAccount => bankAccount.accountType === CLEARING_ACCOUNT) || {}

  if (!offlineKontoId && clearingAccountId) {
    return clearingAccountId
  }
  if (offlineKontoId) {
    return offlineKontoId
  }
  return null
}

export class PaymentFormModel {
  constructor(props = {}) {
    this.customerName = props.customerName || ''
    this.transactionNumber = props.transactionNumber || ''
    this.transactionType = props.transactionType || ''
    this.amount = props.amount || 0
    this.date = props.date || moment().format(config.dateFormat.api)
    this.notes = props.notes || ''
    this.bankAccountId = props.bankAccountId || null
  }

  static fromInvoice(invoice, bankAccounts = []) {
    return new PaymentFormModel({
      customerName: invoice.displayName,
      transactionNumber: invoice.number,
      transactionType: TRANSACTION_TYPE_INVOICE,
      amount: new Decimal(invoice.outstandingAmount).toDP(2).toNumber(),
      notes: lang.paymentNotesTextInvoice(invoice.number),
      bankAccountId: getBankAccountId(bankAccounts),
    })
  }

  static fromExpense(expense, bankAccounts = []) {
    return new PaymentFormModel({
      customerName: expense.payee,
      transactionNumber: expense.receiptNumber,
      transactionType: TRANSACTION_TYPE_EXPENSE,
      amount: new Decimal(expense.outstandingAmount).toDP(2).toNumber(),
      notes: lang.paymentNotesTextExpense(expense.receiptNumber),
      bankAccountId: getBankAccountId(bankAccounts),
    })
  }

  static fromRevenue(revenue, bankAccounts = []) {
    return new PaymentFormModel({
      customerName: revenue.sender || revenue.payee,
      transactionNumber: revenue.receiptNumber,
      transactionType: TRANSACTION_TYPE_REVENUE,
      amount: revenue.outstandingAmount,
      notes: lang.paymentNotesTextRevenue(revenue.receiptNumber),
      bankAccountId: getBankAccountId(bankAccounts),
    })
  }

  static fromCreditNote(creditNote, bankAccounts = []) {
    return new PaymentFormModel({
      customerName: creditNote.displayName,
      transactionNumber: creditNote.number,
      transactionType: TRANSACTION_TYPE_CREDIT_NOTE,
      amount: new Decimal(creditNote.outstandingAmount).toDP(2).toNumber(),
      notes: lang.paymentNotesTextCreditNote(creditNote.number),
      bankAccountId: getBankAccountId(bankAccounts),
    })
  }
  static fromManualCreditNote(manualCreditNote, bankAccounts = []) {
    return new PaymentFormModel({
      customerName: manualCreditNote.displayName,
      transactionNumber: manualCreditNote.number,
      transactionType: TRANSACTION_TYPE_MANUAL_CREDIT_NOTE,
      amount: new Decimal(manualCreditNote.outstandingAmount).toDP(2).toNumber(),
      notes: lang.paymentNotesTextManualCreditNote(manualCreditNote.number),
      bankAccountId: getBankAccountId(bankAccounts),
    })
  }

  validate() {
    return this.amount !== 0
      && this.customerName
      && this.transactionNumber
      && this.bankAccountId
      && this.date
  }
}

export default PaymentFormModel
